// LoadingComponent.js
import React from 'react';
import './styles/LoadingComponent.css'; // Import your CSS for styling

const LoadingComponent = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingComponent;
